/**
 * Collapsible "Other Details" section: Stock No, Model No, Drive Type, Vehicle
 * Type, Engine Cylinders, Doors, Seats, Drive Train, MSRP. Of these only Stock
 * No persists today; the rest are display/edit-only this session (populated
 * from inventory or VIN decode). See BACKEND_GAPS.md.
 *
 * @module vehicleModal/components/OtherDetailsSection
 */
import { Collapse, Form, Input, InputNumber } from "antd";
import React from "react";

export default function OtherDetailsSection() {
  const items = [
    {
      key: "other",
      label: "Other Details",
      // Keep the fields mounted even while the panel is collapsed, otherwise
      // antd lazily mounts them and their values are never registered/saved.
      forceRender: true,
      children: (
        <div className="flex flex-col gap-1">
          <div className="flex flex-row gap-3">
            <Form.Item name="stockNumber" label="Stock No" className="w-1/3">
              <Input placeholder="Stock No" />
            </Form.Item>
            <Form.Item name="modelNumber" label="Model No" className="w-1/3">
              <Input placeholder="Model No" />
            </Form.Item>
            <Form.Item name="driveType" label="Drive Type" className="w-1/3">
              <Input placeholder="Drive Type" />
            </Form.Item>
          </div>
          <div className="flex flex-row gap-3">
            <Form.Item name="vehicleType" label="Vehicle Type" className="w-1/3">
              <Input placeholder="Vehicle Type" />
            </Form.Item>
            <Form.Item name="engineCylinders" label="Engine Cylinders" className="w-1/3">
              <Input placeholder="Engine Cylinders" />
            </Form.Item>
            <Form.Item name="doors" label="Doors" className="w-1/3">
              <Input placeholder="Doors" />
            </Form.Item>
          </div>
          <div className="flex flex-row gap-3">
            <Form.Item name="seats" label="Seats" className="w-1/3">
              <Input placeholder="Seats" />
            </Form.Item>
            <Form.Item name="driveTrain" label="Drive Train" className="w-1/3">
              <Input placeholder="Drive Train" />
            </Form.Item>
            <Form.Item name="msrp" label="MSRP" className="w-1/3">
              <InputNumber prefix="$" placeholder="MSRP" className="w-full" min={0} />
            </Form.Item>
          </div>
        </div>
      ),
    },
  ];

  return (
    <Collapse
      defaultActiveKey={["other"]}
      items={items}
      expandIconPosition="end"
      className="vehicle-section-collapse mt-6"
    />
  );
}
